const HOSTNAMES = ["melsibienestar.com", "www.melsibienestar.com"];
const ORIGIN = "https://analytics.melsibienestar.com";
const WEBSITE_ID = "64c80b26-21a4-42c1-83aa-7a5d3ad8b9b0";
const STATE_KEY = "__melsiAnalytics";
const UTM = new Set(["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]);

const enabled = () => typeof window !== "undefined" && HOSTNAMES.includes(window.location.hostname);

function cleanUrl(value, keepUtm = false) {
    if (!value) return "";
    try {
        const url = new URL(value, window.location.origin);
        const search = new URLSearchParams();
        if (keepUtm) url.searchParams.forEach((value, key) => {
            if (UTM.has(key)) search.append(key, value);
        });
        url.search = search.toString();
        url.hash = "";
        url.username = "";
        url.password = "";
        return value.startsWith("/") ? url.pathname + url.search : url.href;
    } catch {
        return "";
    }
}

function replayAllowed() {
    const url = new URL(window.location.href);
    return !url.href.includes("#") && [...url.searchParams.keys()].every(key => UTM.has(key));
}

export function initializeAnalytics() {
    if (!enabled() || document[STATE_KEY]) return;
    const state = { status: "loading", deadline: Date.now() + 5000 };
    document[STATE_KEY] = state;
    // Remember the entry URL even if Gatsby navigates while the tracker downloads.
    const safeEntry = replayAllowed();
    window.melsiUmamiBeforeSend = (type, payload) => {
        if (!enabled() || type !== "event") return false;
        return { ...payload, url: cleanUrl(payload.url, true), referrer: cleanUrl(payload.referrer) };
    };
    const fail = () => { state.status = "failed"; };
    // An existing node is never duplicated or used to start a second recorder.
    if (document.getElementById("melsi-umami-tracker")) return fail();
    const timeout = window.setTimeout(fail, 5000);
    const script = document.createElement("script");
    script.id = "melsi-umami-tracker";
    script.src = `${ORIGIN}/script.js`;
    script.async = true;
    script.dataset.websiteId = WEBSITE_ID;
    script.dataset.domains = HOSTNAMES.join(",");
    script.dataset.beforeSend = "melsiUmamiBeforeSend";
    script.dataset.excludeHash = "true";
    script.referrerPolicy = "origin";
    script.onerror = () => { window.clearTimeout(timeout); fail(); };
    script.onload = () => {
        window.clearTimeout(timeout);
        if (state.status !== "loading") return;
        if (Date.now() >= state.deadline || !window.umami?.track) return fail();
        state.status = "ready";
        if (!enabled() || !safeEntry || !replayAllowed()) return;
        if (document.getElementById("melsi-umami-recorder")) return;
        const recorder = document.createElement("script");
        recorder.id = "melsi-umami-recorder";
        recorder.src = `${ORIGIN}/recorder.js`;
        recorder.async = true;
        recorder.dataset.websiteId = WEBSITE_ID;
        recorder.referrerPolicy = "origin";
        document.head.appendChild(recorder);
    };
    document.head.appendChild(script);
}
